var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Head',{staticClass:"head"}),_c('lunbo'),_c('router-view'),_c('Tail',{staticStyle:{"background-color":"#414754","color":"#fff"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }